import React, { useEffect, useState } from 'react';

import { Text, TEXT_VARIANTS } from 'ui/Typography';
import request from 'utils/request_ajax';
import CopyLink from 'components/shared/CopyLink';

const ShareableLink = props => {
  const { progressId, questionId, currentChoice } = props;
  const [shareableLink, setShareableLink] = useState('');

  const url = `/progresses/${progressId}/questions/${questionId}/answers/shareable_answer_link_for_question`;

  useEffect(() => {
    const fetchUrl = async () => {
      if (shareableLink) return;
      const { shareable_link } = await request.get(url);
      setShareableLink(shareable_link);
    };

    if (currentChoice) fetchUrl();
  }, [url, shareableLink, currentChoice]);

  return (
    <>
      <div className="d-f jc-c mt-32 WebcamResponses--shareableLink">
        <div className="mt-32 mb-32">
          <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
            {t('practice.repeatability.want_feedback')}{' '}
          </Text>
          <Text variant={TEXT_VARIANTS.BODY}>
            {t('practice.repeatability.share_your_response')}
          </Text>
          <span className="d-f w-fill jc-s m-jc-c mt-8">
            <CopyLink
              link={shareableLink}
              useCustomColor={false}
              className="fz-16 p-12 mh-36 minw-300 lh-20 m-minw-0"
              copyText={t('common.copy_link')}
              useIcon={false}
            />
          </span>
        </div>
      </div>
    </>
  );
};

export default ShareableLink;
